import { BfcmContentCard } from '@klv/molecules/bfcm-content-card';

import { generateClassName } from '@klv/shared/utils/functions';
import { Wrapper } from '@klv/utils/wrapper';

import * as styles from './styles/bfcmFeatureCard.module.scss';

import type { IBfcmFeatureCard } from './types';

const BfcmFeatureCard = ({
  className = '',
  backgroundColor = 'charcoal',
  fontType = 'sohneSchmal',
  headline,
  subheadline,
  eyebrow,
  contentCard,
  contentImage,
  customPadding = {
    customPaddingTop: 'none',
    customPaddingBottom: 'none',
  },
  ...props
}: IBfcmFeatureCard) => {

  const HeadlineComponent = fontType === 'sohneSchmal' ? (
    <div className={styles.headline}>{headline}</div>
  ) : (
    <h2
      className='h3'
      dangerouslySetInnerHTML={{ __html: headline as string }}
    />
  );


  return (
    <Wrapper backgroundColor={backgroundColor} customPadding={customPadding} contained={false}>
      <div
        className={generateClassName([
          className,
          styles.bfcmFeatureCard,
        ])}
        {...props}
      >
        <div className="grid">
          <div className={styles.header}>
            {eyebrow && (
              <div className={`eyebrow ${styles.eyebrow}`}>
                {eyebrow}
              </div>
            )}
            {headline && HeadlineComponent}
            {subheadline && <div className={styles.subheadline}>{subheadline}</div>}
          </div>
          <div className={styles.contentCard}>
            <BfcmContentCard 
              font={fontType} 
              {...contentCard} 
              {...contentImage} />
          </div>
        </div>
      </div>
    </Wrapper>

  );
};

export default BfcmFeatureCard;
